import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FiltroProductos, Producto } from 'src/app/entidades/producto.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductoService {
  baseUrl = environment.apiResrURL;
  productosUrl = `${this.baseUrl}/sgi-productos`;
  estadisticasUrl = `${this.baseUrl}/sgi-estadisticas`;

  constructor(private httpClient: HttpClient) {}

  public listaProductos(): Observable<any> {
    return this.httpClient.get<Producto[]>(`${this.baseUrl}/api/productos`);
  }

  public filtrarProductos(
    page: number,
    size: number,
    filtro: FiltroProductos
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.productosUrl}/api/productos/filtrar?page=${page}&size=${size}`,
      filtro
    );
  }

  public consultarTipos(categoria: any): Observable<any> {
    return this.httpClient.get<any>(
      `${this.productosUrl}/api/productos/tipos?categoria=${categoria}`
    );
  }

  public consultarSubtipos(tipo: any): Observable<any> {
    return this.httpClient.get<any>(
      `${this.productosUrl}/api/productos/subtipos?tipo=${tipo}`
    );
  }

  public consultarMasVendidos(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.estadisticasUrl}/productosMasVendidosDelMes`
    );
  }

  public producto(id: string): Observable<any> {
    const headers = new HttpHeaders().set('From', 'Tienda');

    return this.httpClient.get<Producto>(
      `${this.productosUrl}/api/productos/producto?id=${id}`,
      { headers }
    );
  }
}
